var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"},{name:"b-tooltip",rawName:"v-b-tooltip",value:(_vm.tooltipMessage),expression:"tooltipMessage"}],staticClass:"advanced-filter-activated",attrs:{"id":"filter-badge"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }